import { IProjectEntity } from "./base";
import { IUser } from "./user";
import { RoleNames, RoleValues, SystemRole, SystemRoleValues } from "./permissions";

export interface IProjectScopeUsers {
  id: string,
  roles: RoleNames[],
  teams: RoleNames[],
}
export interface IProjectScope extends IProjectEntity {
  //roles?: string[];
  //usergroups?: string[];
  users?: IProjectScopeUsers[];
}

export function isUserInScope(user: IUser, scope: IProjectScope): boolean {
  const roles: SystemRoleValues[] = [SystemRole.SysAdmin, SystemRole.SuperUser];
  if (user?.globalRoleId && roles.includes(user.globalRoleId)) {
    return true;
  }
  if (!scope || !scope.users) {
    return false;
  }
  return !!user && scope.users.some(u => u.id === '#everyone#' || u.id === user.id);
}

export function isUserInProjectScope(user: IUser, scope: IProjectScope): boolean {
  if (!scope || !scope.users) {
    return true;
  }
  return !!user && scope.users.some(u => !u.roles.includes(SystemRole.Viewer) && (u.id === '#everyone#' || u.id === user.id));
}
